import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "select-fields" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "options-heading" }
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = ["onClick"]

import StudioSelectField from "../../../StudioSelectField.vue";
import { computed, inject, watchEffect, type Ref } from "vue";
import type { SelectClip } from "../../types/DialogueNode";
import { getSelectStyles } from "../../config/selectStyleRegistry";
import { createSelectOption } from "../../utils/dialogueProject";
import SelectOptionIcon from "../SelectOptionIcon.vue";
import { applyStyleParameters, syncStyleParameters } from "../../utils/styleParameters";
import StyleParameterFields from "./StyleParameterFields.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectClipEditor',
  props: {
    clip: {}
  },
  setup(__props: any) {

const props = __props;
const selectStyles = inject<Ref<ReturnType<typeof getSelectStyles>>>("selectStyleOptions", computed(() => getSelectStyles()));
const stylesReady = inject<Ref<boolean>>("selectStylePresetsReady", computed(() => true));
watchEffect(() => { if (stylesReady.value) syncStyleParameters(props.clip, selectStyles.value); });
const selectedStyle = computed({
  get: () => props.clip.style,
  set: (value: string) => {
    props.clip.style = value;
    applySelectedStyle();
  },
});
const changedParameters = computed(() => {
  const style = selectStyles.value.find(item => item.id === props.clip.style);
  return stylesReady.value && style && JSON.stringify(style.parameters ?? []) !== JSON.stringify(props.clip.parameterPreset?.parameters ?? []);
});
function applySelectedStyle() {
  if (!stylesReady.value) return;
  const style = selectStyles.value.find(item => item.id === props.clip.style);
  if (style) applyStyleParameters(props.clip, style);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, [
      _cache[3] || (_cache[3] = _createTextVNode(" 选项样式 ", -1)),
      _createVNode(StudioSelectField, {
        modelValue: selectedStyle.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedStyle).value = $event)),
        disabled: !_unref(stylesReady),
        "aria-label": "选项样式"
      }, {
        default: _withCtx(() => [
          (!_unref(selectStyles).some(item => item.id === __props.clip.style))
            ? (_openBlock(), _createElementBlock("option", {
                key: 0,
                value: __props.clip.style
              }, _toDisplayString(__props.clip.style || '未设置') + "（当前值）", 9, _hoisted_2))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectStyles), (style) => {
            return (_openBlock(), _createElementBlock("option", {
              key: style.id,
              value: style.id
            }, _toDisplayString(style.label) + "（" + _toDisplayString(style.id) + "） ", 9, _hoisted_3))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("small", { class: "select-hint" }, " 黄色标记控制 ContinueDelayTime；Select 的右边界始终跟随 Timeline 末尾。 ", -1)),
    _createElementVNode("div", _hoisted_4, [
      _cache[4] || (_cache[4] = _createElementVNode("strong", null, "选项内容 / 图标", -1)),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.clip.options.push(_unref(createSelectOption)())))
      }, " ＋ 选项 ")
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.clip.options, (option, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: option.id,
        class: "option-row"
      }, [
        _createElementVNode("span", null, _toDisplayString(index + 1), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": ($event: any) => ((option.content) = $event),
          placeholder: "Content"
        }, null, 8, _hoisted_5), [
          [_vModelText, option.content]
        ]),
        _createVNode(SelectOptionIcon, {
          modelValue: option.icon,
          "onUpdate:modelValue": ($event: any) => ((option.icon) = $event),
          label: `选项 ${index + 1} 图标`
        }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]),
        _createElementVNode("button", {
          type: "button",
          "aria-label": "删除选项",
          onClick: ($event: any) => (__props.clip.options.splice(index, 1))
        }, " × ", 8, _hoisted_6)
      ]))
    }), 128)),
    _createVNode(StyleParameterFields, {
      modelValue: __props.clip.params,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.clip.params) = $event)),
      parameters: __props.clip.parameterPreset?.parameters,
      label: "选项卡参数",
      "preset-label": "选项卡类型"
    }, null, 8, ["modelValue", "parameters"]),
    (changedParameters.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "apply-parameters",
          type: "button",
          onClick: applySelectedStyle
        }, "应用预设参数（恢复默认值）"))
      : _createCommentVNode("", true)
  ]))
}
}

})